import { combineReducers } from "redux";
import Visits from "./Visits";
import worklistReducer from "./worklistReducer";
import parkedReducer from "./parkedReducer";
import submittedForVerificationReducer from "./submittedForVerificationReducer";
import reportViewerReducer from "./reportViewerReducer";
import verifiedReducer from "./verifiedReducer";

const mrtReducer = combineReducers({
    visits: Visits,
    worklist: worklistReducer,
    parked: parkedReducer,
    submittedForVerification: submittedForVerificationReducer,
    verified: verifiedReducer,
    reportViewer: reportViewerReducer

});

export default mrtReducer;
